import { Body, CardLink, Icon, CardLinkProps, Headline } from "~/ui-library";
import { ArrowRightIcon } from "~/ui-library/icons";

export interface RelatedStoryCardProps extends Omit<CardLinkProps, "children"> {
  headline: string;
  href: string;
}

export const RelatedStoryCard = ({
  headline,
  href,
}: RelatedStoryCardProps): JSX.Element => (
  <CardLink className="flex p-s md:p-m" href={href}>
    <div className="flex shrink grow flex-col items-start gap-xxs md:flex-row md:items-center md:gap-s">
      <Headline className="shrink-0" level={6} blockCase>
        Related:
      </Headline>
      <Body className="shrink text-primary" bold>
        {headline}
      </Body>
    </div>

    <div className="flex min-w-[2rem] items-center justify-end text-primary">
      <Icon SvgIcon={ArrowRightIcon} title="arrow right" size="small" />
    </div>
  </CardLink>
);
